/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type DesignProfileStatus = "ACTIVE" | "DELETED" | "NEW" | "PENDING" | "%future added value";
export type ProjectsRoot_viewer = {
    readonly designFirm?: ReadonlyArray<{
        readonly serviceId: string | null;
        readonly profileStatus: DesignProfileStatus | null;
        readonly publicProfile: {
            readonly urlLabel: string | null;
            readonly liveDesignProjects?: ReadonlyArray<{
                readonly serviceId: string | null;
                readonly status: string | null;
                readonly " $fragmentRefs": FragmentRefs<"DisplayDesignProjectTile_designProject">;
            } | null> | null;
            readonly editModeDesignProjects?: ReadonlyArray<{
                readonly serviceId: string | null;
                readonly status: string | null;
                readonly " $fragmentRefs": FragmentRefs<"EditDesignProjectTile_designProject">;
            } | null> | null;
        } | null;
    } | null> | null;
    readonly " $refType": "ProjectsRoot_viewer";
};
export type ProjectsRoot_viewer$data = ProjectsRoot_viewer;
export type ProjectsRoot_viewer$key = {
    readonly " $data"?: ProjectsRoot_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ProjectsRoot_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "firmUrlLabel"
    },
    {
      "kind": "RootArgument",
      "name": "isEditMode"
    },
    {
      "kind": "RootArgument",
      "name": "shouldRenderProjects"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectsRoot_viewer",
  "selections": [
    {
      "condition": "shouldRenderProjects",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "designFirm",
          "args": [
            {
              "kind": "Literal",
              "name": "pageSize",
              "value": 1
            },
            {
              "kind": "Variable",
              "name": "urlLabel",
              "variableName": "firmUrlLabel"
            }
          ],
          "concreteType": "TradeFirmType",
          "kind": "LinkedField",
          "name": "tradeFirms",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "profileStatus",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "TradeFirmPublicProfileType",
              "kind": "LinkedField",
              "name": "publicProfile",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "urlLabel",
                  "storageKey": null
                },
                {
                  "condition": "isEditMode",
                  "kind": "Condition",
                  "passingValue": false,
                  "selections": [
                    {
                      "alias": "liveDesignProjects",
                      "args": null,
                      "concreteType": "DesignProjectCover",
                      "kind": "LinkedField",
                      "name": "designProjectsCover",
                      "plural": true,
                      "selections": [
                        (v0/*: any*/),
                        (v1/*: any*/),
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "DisplayDesignProjectTile_designProject"
                        }
                      ],
                      "storageKey": null
                    }
                  ]
                },
                {
                  "condition": "isEditMode",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "alias": "editModeDesignProjects",
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "status",
                          "value": [
                            "ACTIVE",
                            "PENDING"
                          ]
                        },
                        {
                          "kind": "Literal",
                          "name": "visibility",
                          "value": [
                            "Y",
                            "N"
                          ]
                        }
                      ],
                      "concreteType": "designProject",
                      "kind": "LinkedField",
                      "name": "designProjects",
                      "plural": true,
                      "selections": [
                        (v0/*: any*/),
                        (v1/*: any*/),
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "EditDesignProjectTile_designProject"
                        }
                      ],
                      "storageKey": "designProjects(status:[\"ACTIVE\",\"PENDING\"],visibility:[\"Y\",\"N\"])"
                    }
                  ]
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();
(node as any).hash = 'a617128cc9d7bdf4ff69045a6090657f';
export default node;
